import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      fontSize: '11pt',
      margin: theme.spacing(2, 0, 4, 0),
      color: theme.palette.common.black,
      textAlign: 'justify',
      '&.smaller': {
        fontSize: '9pt',
      },
      '&.supplement': {
        fontSize: '9pt',
        color: theme.palette.grey['600'],
      },
      '&.noMargin': {
        margin: 0,
      },
      '&.tight': {
        marginBottom: theme.spacing(3),
      },
      '&.tighter': {
        marginBottom: theme.spacing(2),
      },
      '&.noBottomMargin': {
        marginBottom: theme.spacing(0),
      },
      '& + ul': { marginTop: theme.spacing(-2) }
    },
  }),
);

export default useStyles;
